import localforage from "localforage";
import {AppDispatch} from "../app/store";
import {IItem} from "../interfaces/Item";
import {HORIZONTAL_LINE, VERTICAL_LINE} from "../utils/ItemTypes";
import {
  ADD_ITEM_TO_LABEL,
  SET_SELECTED_ITEM,
  SET_COORDINATES,
  CHANGE_VALUE,
  CHANGE_LABEL_PARAMS,
  REMOVE_ITEM_FROM_LABEL,
  CHANGE_LINE_VALUE,
  CHANGE_OBJECT_RESIZE,
  CHANGE_BARCODE_RESIZE,
  CHANGE_VALUE_WITH_STYLE,
  CHANGE_VALUE_NO_HISTORY,
  CHANGE_PICTURE,
  NEW_LABEL,
  REMOVE_ALL_SELECTION,
  CLEAR_ALL_ITEMS,
  SET_ZOOM,
  SET_COORDINATES_NO_HISTORY,
  SET_RECID
} from "./MainReducer";

export const AddItemToLabel = (item: IItem) => {
  return async (dispatch: AppDispatch) => {
    dispatch({type: ADD_ITEM_TO_LABEL, item});
  };
};

export const RemoveAllSelection = () => {
  return async (dispatch: AppDispatch) => {
    dispatch({type: REMOVE_ALL_SELECTION});
  };
};

export const SelectItem = (item: IItem) => {
  return (dispatch: AppDispatch) => {
    if (item.selected) return;
    dispatch({type: SET_SELECTED_ITEM, item});
  };
};

export const NewLabel = () => {
  return (dispatch: AppDispatch) => {
    localforage.clear();
    dispatch({type: NEW_LABEL});
    dispatch({type: SET_RECID, recid: -1, templateName: ""});
    
    
  };
};
export const ClearAll = () => {
  return (dispatch: AppDispatch) => {
    localforage.clear();
    dispatch({type: CLEAR_ALL_ITEMS});
  };
};

export const SetCoordinates = (item: IItem, x: number, y: number, noHistory: boolean = false) => {
  return (dispatch: AppDispatch) => {
    if (item.selected === false) {
      dispatch(SelectItem(item));
    }
    dispatch({type: noHistory ? SET_COORDINATES_NO_HISTORY : SET_COORDINATES, item, x, y});
  };
};

export const ChangeValue = (item: IItem, propName: string, propValue: any) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_VALUE, item, propName, propValue});
  };
};
export const ChangeValueNoHistory = (item: IItem, propName: string, propValue: any) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_VALUE_NO_HISTORY, item, propName, propValue});
  };
};
export const ChangeLineValue = (item: IItem, x: number, y: number, xTo: number, yTo: number) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false || (item.type !== HORIZONTAL_LINE && item.type !== VERTICAL_LINE)) {
      return;
    }
    dispatch({type: CHANGE_LINE_VALUE, item, x, y, xTo, yTo});
  };
};

export const ChangeObjectResize = (item: IItem, width: number, propName: string, propValue: number) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_OBJECT_RESIZE, item, width, propName, propValue});
  };
};

export const ChangeObjectWithStyle = (item: IItem, propName: string, propValue: any, propNameStyle: string, propValueStyle: any) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_VALUE_WITH_STYLE, item, propName, propValue, propNameStyle, propValueStyle});
  };
};
export const ChangePicture = (item: IItem, value: string, path: string) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_PICTURE, item, value, path});
  };
};

export const ChangeBarcodeResize = (item: IItem, width: number, height: number, value: string) => {
  return async (dispatch: AppDispatch) => {
    if (item.selected === false) {
      return;
    }
    dispatch({type: CHANGE_BARCODE_RESIZE, item, width, height, value});
  };
};

export const ChangeLabelParams = (propName: string, propValue: any) => {
  return (dispatch: AppDispatch) => {
    dispatch({type: CHANGE_LABEL_PARAMS, propName, propValue});
  };
};

export const DeleteSelectedItem = () => {
  return (dispatch: AppDispatch) => {
    dispatch({type: REMOVE_ITEM_FROM_LABEL});
  };
};

export const SetZoomValue = (zoom: number) => {
  return (dispatch: AppDispatch) => {
    localforage.setItem("zoom", zoom.toString());
    dispatch({type: SET_ZOOM, zoom});
  };
}